import { createSlice } from '@reduxjs/toolkit';

const DEFAULT_USER_STATE = {
    email: '',
    userName: '',
    firstName: '',
    lastName: '',
    isActive: false,
    token: '',
    exp: 0,
};
export const adminDataSlice = createSlice({
    name: 'adminData',
    initialState: {
        user: DEFAULT_USER_STATE
    },
    reducers: {
        updateAdminUser: (state, action) => {
            state.user = {...state.user, ...action.payload}
        },
        cleanAdminUser: (state) => {
            state.user = {...DEFAULT_USER_STATE}
        },
        updateAdminData: (state, action) => {
            if (action.payload?.user) {
                state.user = { ...state.user, ...action.payload.user };
            }
        },
        cleanAdminData: (state) => {
            state.user = { ...DEFAULT_USER_STATE };
        }
    }
});
export const { 
    updateAdminUser, cleanAdminUser,
    updateAdminData, cleanAdminData 
} = adminDataSlice.actions;
export default adminDataSlice.reducer;